import {
  DestroyTrainingDocument,
  DestroyTrainingMutation,
  DestroyTrainingMutationVariables,
  TrainingsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDestroyTraining = () => {
  const [destroyTraining, { loading }] = useMutation(DestroyTrainingDocument, {
    extractorFn: (data: DestroyTrainingMutation) =>
      data.trainingsMutations.bulkDeleteTrainingsTraining,
  })

  return {
    loading,
    destroyTraining(variables: DestroyTrainingMutationVariables) {
      return destroyTraining({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [TrainingsDataCollectionDocument],
      })
    },
  }
}
